import { Icon, type IconGlyphProps } from 'BomdisoftComponents/icons/base';
import { REPORT_PROBLEM_OUTLINED_GLYPH } from 'BomdisoftComponents/icons/glyphs';

export const ReportProblemOutlinedIcon = (props: IconGlyphProps) => <Icon {...props} glyph={REPORT_PROBLEM_OUTLINED_GLYPH} />;
